// extracted by mini-css-extract-plugin
export default {"buttonPair":"ButtonPair_buttonPair__RVAVU","primary":"ButtonPair_primary__jUNAX","secondary":"ButtonPair_secondary__oz1w9"};